/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const departmentsSchema = z.object({
      "code": z.string().optional(),
  "label": z.string().optional()
      })